import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportOperatorViolations = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/violations/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportOperatorViolations;
